<template>
    <div>
        <b-modal v-model="mostrarModal" @show="iniciarForm()">
            <div slot="modal-title">Relação de cancelamentos das entregas</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Unidade das Contratações</label>
                        <b-form-select
                            :plain="true"
                            :options="unidades"
                            text-field="unidade"
                            value-field="codUnidade"
                            v-model="unidade"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="perfil != 'gestor'">
                <b-col sm="12">
                    <b-form-group>
                        <label>Gestor das Contratações</label>
                        <b-form-select
                            :plain="true"
                            :options="gestores"
                            text-field="gestor"
                            value-field="codGestor"
                            v-model="gestor"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Data Comunic. do Cancelamento (DE)</label>
                        <date-picker
                            v-model="dataComunicacaoCancelamentoDe"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Data Comunic. do Cancelamento (ATÉ)</label>
                        <date-picker
                            v-model="dataComunicacaoCancelamentoAte"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Data Execução do Cancelamento (DE)</label>
                        <date-picker
                            v-model="dataExecucaoCancelamentoDe"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Data Execução do Cancelamento (ATÉ)</label>
                        <date-picker
                            v-model="dataExecucaoCancelamentoAte"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button variant="primary" @click.stop="filtrar()"
                    >Emitir Relatório</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        servicos: {
            type: Object
        },

        perfil: {
            type: String
        }
    },

    data() {
        return {
            mostrarModal: false,
            unidades: [],
            unidade: -1,
            gestores: [],
            gestor: -1,
            dataComunicacaoCancelamentoDe: null,
            dataComunicacaoCancelamentoAte: null,
            dataExecucaoCancelamentoDe: null,
            dataExecucaoCancelamentoAte: null
        }
    },

    methods: {
        iniciarForm() {
            this.$store.dispatch('addRequest')
            this.servicos.obterOpcoesFiltro().then((response) => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data.unidades
                        this.unidades.unshift({
                            codUnidade: -1,
                            unidade: 'TODAS'
                        })
                        if (this.perfil != 'gestor') {
                            this.gestores = response.data.gestores
                            this.gestores.unshift({
                                codGestor: -1,
                                gestor: 'TODOS'
                            })
                        }
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções dos filtros',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
        },

        filtrar() {
            let filtroDto = {}
            if (this.unidade != -1) {
                filtroDto.unidade = this.unidade
            }

            if (this.gestor != -1 && this.perfil != 'gestor') {
                filtroDto.gestor = this.gestor
            }

            if (this.dataComunicacaoCancelamentoDe) {
                filtroDto.dataComunicacaoCancelamentoDe = this.$moment(
                    this.dataComunicacaoCancelamentoDe,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataComunicacaoCancelamentoAte) {
                filtroDto.dataComunicacaoCancelamentoAte = this.$moment(
                    this.dataComunicacaoCancelamentoAte,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataExecucaoCancelamentoDe) {
                filtroDto.dataExecucaoCancelamentoDe = this.$moment(
                    this.dataExecucaoCancelamentoDe,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataExecucaoCancelamentoAte) {
                filtroDto.dataExecucaoCancelamentoAte = this.$moment(
                    this.dataExecucaoCancelamentoAte,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }
            this.$emit('filtrar', filtroDto)
        }
    }
}
</script>
